"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Package import
 */
const react_1 = __importStar(require("react"));
const crumble_1 = require("@oclock/crumble");
const react_toastify_1 = require("react-toastify");
const MargedInput_1 = require("./MargedInput");
/**
 * Local import
 */
const instances_1 = __importDefault(require("src/store/apis/instances"));
const defaultCreateInstanceBody = {
    short_name: '',
    email: '',
    firstname: '',
    lastname: '',
};
const CreateDialog = ({ setOpen, refetchInstances }) => {
    const [inputCreate, setInputCreate] = (0, react_1.useState)(defaultCreateInstanceBody);
    const [loadCreate, setLoadCreate] = (0, react_1.useState)(false);
    const [createInstance] = instances_1.default.useCreateInstanceMutation();
    const handleChangeCreate = (evt) => {
        setInputCreate(Object.assign(Object.assign({}, inputCreate), { [evt.target.id]: evt.target.value }));
    };
    const handleCancel = () => setOpen(false);
    const handleSuccess = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setLoadCreate(true);
            yield createInstance(inputCreate).unwrap();
            (0, react_toastify_1.toast)('L’instance a bien été créée.', { type: 'success' });
            refetchInstances();
        }
        catch (err) {
            (0, react_toastify_1.toast)('L’instance n’a pas pu être créée, veuillez réessayer.', { type: 'error' });
        }
        setLoadCreate(false);
        setOpen(false);
    });
    const isFormValid = () => {
        return inputCreate.short_name.length > 0 && inputCreate.email.length > 0 && inputCreate.firstname.length > 0 && inputCreate.lastname.length > 0;
    };
    return (react_1.default.createElement(crumble_1.Dialog, { title: "Nouvelle instance", desc: "Donne un nom \u00E0 l'instance et valide pour cr\u00E9er une nouvelle instance.", cancelButtonProps: {
            type: 'button',
            onClick: handleCancel,
            disabled: loadCreate,
            label: "Annuler"
        }, successButtonProps: {
            type: 'button',
            onClick: handleSuccess,
            disabled: !isFormValid() || loadCreate,
            label: loadCreate ? 'Création en cours...' : 'Créer l\'instance'
        } },
        react_1.default.createElement(MargedInput_1.MargedInputField, { type: "text", placeholder: "Tapez le nom de l'instance", label: "Nom de l'instance", value: inputCreate.short_name, onChange: handleChangeCreate, id: "short_name" }),
        react_1.default.createElement(MargedInput_1.MargedInputField, { type: "text", placeholder: "Tapez le pr\u00E9nom de l'administrateur", label: "Pr\u00E9nom de l'administrateur", value: inputCreate.firstname, onChange: handleChangeCreate, id: "firstname" }),
        react_1.default.createElement(MargedInput_1.MargedInputField, { type: "text", placeholder: "Tapez le nom de l'administrateur", label: "Nom de l'administrateur", value: inputCreate.lastname, onChange: handleChangeCreate, id: "lastname" }),
        react_1.default.createElement(MargedInput_1.MargedInputField, { type: "email", placeholder: "Tapez l'email de l'administrateur", label: "Email de l'administrateur", value: inputCreate.email, onChange: handleChangeCreate, id: "email" })));
};
exports.default = CreateDialog;
